import React, { useState, useEffect } from "react";
import {FaAngleLeft, FaAngleRight } from "react-icons/fa";
import "./home.css";
import basketball from "../../assets/basketball.jpg";
import kl from "../../assets/kl.jpg";
import putrajaya from "../../assets/putrajaya.jpg";

// import ImageSlider from "../ImageSlider";

const Home = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((currentIndex + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  const slides = [
    {
      image: basketball,
      // description: "Slide 1"
    },
    {
      image: kl,
      // description: "Slide 2"
    },
    {
      image: putrajaya,
      // description: "Slide 3"
    }
  ];

  const prevSlide = () => {
    setCurrentIndex(currentIndex === 0 ? slides.length - 1 : currentIndex - 1);
  };

  const nextSlide = () => {
    setCurrentIndex((currentIndex + 1) % slides.length);
  };


  return (
    <div className="slider">
      <img className="home__img" src={slides[currentIndex].image} alt={slides[currentIndex].description} />
      <p>{slides[currentIndex].description}</p>
      <button className="btn__prev " onClick={prevSlide}><FaAngleLeft/> </button>
      <button className="btn__next "onClick={nextSlide}><FaAngleRight className="icon"/></button>
    </div>
  );
};
export default Home;
